import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "mb-3 small" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "row align-middle" };
const _hoisted_5 = { class: "col-sm-5 text-end pl-0" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "mb-3 small" };
const _hoisted_8 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_9 = { class: "row align-middle" };
const _hoisted_10 = { class: "col-sm-5 text-end mt-2 pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$appHost.pageMeta.title,
        "back-link-path": "/login"
    }, {
        default: _withCtx(() => [
            (_ctx.$route.hash == '#submit')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", {
                            innerHTML: _ctx.$t('account.Login.Recovery.Note.Sent')
                        }, null, 8, _hoisted_3)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-sm-7" }, null, -1)),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_g_button, {
                                text: _ctx.$t('account.Back'),
                                onClick: _ctx.OnBack,
                                "button-style": "btn-outline-secondary"
                            }, null, 8, ["text", "onClick"])
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('account.Login.Recovery.Note')), 1),
                    _createVNode(_component_g_form, { ref: "frmMain" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_g_text_field, {
                                dataObject: _ctx.$data,
                                label: _ctx.$t('account.EMailAddress') + '*',
                                mode: "email",
                                "data-member": "eMailAddress",
                                "data-mode": "model",
                                "show-clear-button": true,
                                "validation-rules": { required: true, type: 'email' },
                                onEnterKey: _ctx.OnExecute
                            }, null, 8, ["dataObject", "label", "onEnterKey"])
                        ]),
                        _: 1
                    }, 512),
                    (_ctx.hasError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-sm-7" }, null, -1)),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_g_button, {
                                text: _ctx.$t('account.Login.Recovery.SendLink'),
                                "is-loading": _ctx.isWorking,
                                disabled: _ctx.disableSubmit,
                                onClick: _ctx.OnExecute
                            }, null, 8, ["text", "is-loading", "disabled", "onClick"])
                        ])
                    ])
                ]))
        ]),
        _: 1
    }, 8, ["title"]));
}
